<template>
   
    <iframe
          
          width="100%"
            height="500"
            :src="host + lista_evento.videos_id" 
          frameborder="0"
          
          allowfullscreen
          allow="autoplay;muted;loop;"
          autoplay
      loop
        ></iframe> 
  
</template>
<script>
  import myVideo from 'vue-video'
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal,myVideo
  },
  data() {
    return {
    
      host: process.env.VUE_APP_API_URL + "arquivo/banners/",
    };
  },
  computed: {
    lista_evento() {
      return this.$store.state.evento.evento;
    },
  
  },

};
</script>

<style>
/* img {
  border-radius: 20px;
} */
strong {
  font-weight: 600;
}
.card {
  margin-top: 10px;
  border: 2px solid rgb(166, 166, 166);
  border-radius: 20px;
  color: black;
  /* -webkit-transition: -webkit-transform 0.5s ease;
  transition: transform 0.5s ease; */
}
/* 
.card:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
} */
</style>
